import React from 'react';
import { Helmet } from 'react-helmet';
import _ from 'lodash';

import { PrimaryCompanyNaviList } from '../components/list/PrimaryCompanyNaviList';
import { Description } from '../components/Description';
import { MasterPageHeader } from '../components/PageHeader';
import { Information } from '../components/modals/common';
import Loader from '../components/Loader';
import {
  FormList,
  FormListSubHeader,
} from '../components/CommonFormComponents';
import { HEADER_CONSTANTS } from '../utilities/constants';
import _masterSlideLoader from '../utilities/masterSlideLoader';
import ImageUtility from '../utilities/imageUtility';
import { messageUtility } from '../utilities/messageUtility';
import { isLoginUserPrime } from '../utilities/roleUtility';
import SessionStorageService from '../services/utilities/SessionStorageService';
import KmobileService from '../services/Kmobile';
import CompanyService from '../services/Companies';

export class DeleteKmobileDevice extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      companyId: SessionStorageService.getCompanyId(),
      expirationCompany: {},
      isVisibleDialog: '',
      dialogState: {
        title: '',
        message: '',
        rootClassName: '',
      },
    };
    this.isImportingFlag = false;
    this.fileButtonRef = React.createRef();
    const isKajima = SessionStorageService.isKajimaCompany();
    if (!isKajima || !isLoginUserPrime()) {
      return window.location.replace('/error-permission');
    }
  }

  getExpiration = async () => {
    await CompanyService.expirations(this.state.companyId).then(response => {
      if (!response.result) {
        return;
      }
      this.setState({
        expirationCompany: {
          ...this.state.expirationCompany,
          ...response.data.entities.company.expiration,
        },
      });
    });
  };

  componentDidMount = () => {
    this.getExpiration();
  };

  selectFileCheck = async file => {
    if (this.isImportingFlag) {
      return;
    }
    this.fileButtonRef.current.value = '';
    const isValidType = await ImageUtility.approvalFileType(file, ['xlsx']);
    const isValidSize = await ImageUtility.fileSizeCheck(file);

    if (!isValidType) {
      return this.handleVisibleDialog(
        messageUtility.getMessage('E-001-402'),
        messageUtility.getMessage('E-000-059')
      );
    }

    if (!isValidSize) {
      return this.handleVisibleDialog(
        messageUtility.getMessage('E-001-402'),
        messageUtility.getMessage('E-000-044')
      );
    }
    this.isImportingFlag = true;
    const form = new FormData();
    form.append('file', file);
    try {
      Loader.start();
      const response = await KmobileService.bulkUpdate(form);
      const isImportSuccess = _.get(response, 'result');
      const dialogMessage = _.get(response, 'message');
      const errorMessageList = _.get(response, 'data.error_messages');
      this.setState({
        dialogMessage,
      });
      if (isImportSuccess) {
        this.handleVisibleDialog(
          '削除完了',
          messageUtility.getMessage('I-000-213')
        );
      } else {
        this.showErrorDialog(errorMessageList, dialogMessage);
      }
    } catch (error) {
      this.handleVisibleDialog(
        messageUtility.getMessage('E-001-402'),
        messageUtility.getMessage('E-001-425')
      );
    } finally {
      Loader.done();
      this.isImportingFlag = false;
    }
  };

  showErrorDialog = (errorMessageList, dialogMessage) => {
    let rootClassName;
    if (!_.isEmpty(errorMessageList)) {
      dialogMessage = (
        <React.Fragment>
          {dialogMessage}
          <br />
          <br />
          <div className='error-message-list'>
            {errorMessageList.join('\n')}
          </div>
        </React.Fragment>
      );
      rootClassName = 'delete-kmobile-device-error';
    }
    this.handleVisibleDialog(
      messageUtility.getMessage('E-001-426'),
      dialogMessage,
      rootClassName
    );
  };

  handleVisibleDialog(title, message, rootClassName) {
    this.setState({
      isVisibleDialog: true,
      dialogState: {
        title,
        message,
        rootClassName,
      },
    });
  }

  render() {
    const { isVisibleDialog, dialogState } = this.state;
    return (
      <div
        id='slide-view'
        className='contruction-slide-view show DeleteKmobileDevice'
      >
        <Helmet>
          <title>{HEADER_CONSTANTS.title} - 会社情報</title>
        </Helmet>
        <div className='contruction-slide-view__view'>
          <MasterPageHeader
            title={'会社情報'}
            onClose={() => _masterSlideLoader.close()}
          />
          <div className='contruction-slide-view__body contruction-slide-view__body--height-fix'>
            <div className='contruction-detail-view'>
              <div className='contruction-detail-view__sidemenu'>
                <PrimaryCompanyNaviList
                  isSelectedDeleteKmobileDevice={true}
                  expirationCompany={this.state.expirationCompany}
                />
              </div>
              <div className='contruction-detail-view__body contruction-detail-view__body--fixed'>
                <div className='contruction-detail-view__main contruction-detail-view__main--fixed contruction-detail-view__main--fix'>
                  <FormList>
                    <FormListSubHeader
                      title='K-Mobile端末の削除'
                      noMarginTop={true}
                    />
                    <div className='kmobile_guide'>
                      <Description type='primary'>
                        <span className='kmobile_guide__content'>
                          {messageUtility.getMessage('I-000-212')}
                        </span>
                      </Description>
                    </div>
                    <label
                      htmlFor='delete-kmobile-device-file'
                      className='btn input-file'
                    >
                      ファイル選択
                      <input
                        id='delete-kmobile-device-file'
                        type='file'
                        ref={this.fileButtonRef}
                        accept='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                        onChange={e => this.selectFileCheck(e.target.files[0])}
                      />
                    </label>
                  </FormList>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Information
          buttonText={messageUtility.getMessage('I-000-017')}
          onClose={() => this.setState({ isVisibleDialog: false })}
          multilineText={true}
          visible={isVisibleDialog}
          {...dialogState}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/DeleteKmobileDevice.jsx